import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useBreakpoints } from '../../support/hooks/useBreakpoints.tsx';
import { FloatingButtonBar } from '../button/FloatingButtonBar.tsx';
import { SIDE_DRAWER_WIDTH } from './Drawer.tsx';
import { DrawerState } from './DrawerState.ts';

export const DrawerButtons: React.FC<{children: React.ReactNode}> = ({ children }) => {

    const { isLargerScreen: sideDrawer } = useBreakpoints();

    const drawerState = useInstance(DrawerState);

    return (
        <FloatingButtonBar width={sideDrawer ? SIDE_DRAWER_WIDTH : '100%'} horizontalOffset={-16} verticalOffset={drawerState.getNavBarOffset()}>
            {children}
        </FloatingButtonBar>
    );
};
